export const routes = (parentName) => {
  return [
    {
      path: "chats",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-Chats`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-Chats-New`,
          component: () => import("./Upsert.vue"),
        },
        {
          path: ":id",
          name: parentName + "-" + "Chats-View",
          component: () => import("./View.vue"),
        },
        {
          path: ":id/edit",
          name: parentName + "-" + "Chats-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
